import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const isNewbuilding: TComputedPropMapper<boolean> = ({ offer }): boolean => {
  const { category } = offer;

  return category === 'newBuildingFlatSale';
};
